import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../../../partials/aside/Sidebar";
import TitleBar from "../../../../partials/content/TitleBar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helperTime from "../../../../../helpers/time";
import helperNumbers from "../../../../../helpers/numbers";
import MessageConstant from "./../../manage/MessageConstant";

export default function AllMessage() {
  const params = useParams();
  const positionID = parseInt(params.positionID);
  const [allMessages, setAllMessages] = useState([]);

  useEffect(() => {
    getAllMessage();
  }, []);

  const getAllMessage = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allMessages = await sendRequestGetAllMessage(positionID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allMessages) {
      return;
    }
    setAllMessages(allMessages);
  };

  const sendRequestGetAllMessage = async (positionID) => {
    const headersRequest = getHeaderRequest();
    let allMessages;
    try {
      allMessages = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/manage/publisher/position/${positionID}/all-message`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allMessages.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generatePositionDoseNotHaveMessages = () => {
    return <p className="alert alert-info">این جایگاه هیچ پیغامی ندارد</p>;
  };

  const generateMessages = () => {
    return (
      <div>
        {allMessages.map((message) => {
          let classNameContainerMessage;
          switch (message.mep_user_type) {
            case MessageConstant.typeUser.PUBLISHER:
              classNameContainerMessage = "warning";
              break;
            case MessageConstant.typeUser.OPERATOR:
              classNameContainerMessage = "primary";
              break;
          }
          return (
            <>
              <hr />
              <div className={`alert alert-${classNameContainerMessage}`}>
                <ul className="list-unstyled">
                  <li>
                    <span>حالت منتقل شده :</span>
                    <span>
                      {
                        MessageConstant.getStringStatusMessage()[
                          message.mep_state
                        ]
                      }
                    </span>
                  </li>
                  <li>
                    <span>کاربر ارسال کننده پیغام : </span>
                    <span>
                      {
                        MessageConstant.getStringTypeUser()[
                          message.mep_user_type
                        ]
                      }
                    </span>
                  </li>
                  <li>
                    <span>تاریخ ارسال پیغام : </span>
                    <span>
                      {helperNumbers.toPersianNum(
                        message.mep_created_at.split(" ")[1] +
                          " " +
                          helperTime.convertGregorianToJalali(
                            message.mep_created_at.split(" ")[0]
                          )
                      )}
                    </span>
                  </li>
                  <li>
                    <span>متن پیغام : </span>
                    <span>
                      <p style={{ whiteSpace: "pre-line" }}>
                        {message.mep_message}
                      </p>
                    </span>
                  </li>
                </ul>
              </div>
            </>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="پیغام های رد بدل شده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to={`/position/manage/independent/${positionID}`}
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div>
                {allMessages.length > 0
                  ? generateMessages()
                  : generatePositionDoseNotHaveMessages()}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
